__turbopack_context__.v({
  "heading": "styles-module__xxv-eG__heading",
});
